import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import isSafeUrl from '@/shared/utils/urlHelpers';

import './DataSourceTile.css';

const DataSourceTile = memo(function DataSourceTile({
    title,
    description,
    metadata,
    detailUrl,
    ctaText = 'Ask Bili about this dataset',
    ctaLink,
    onClick,
    organization,
}) {
    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (ctaLink && isSafeUrl(ctaLink)) {
            window.location.href = ctaLink;
        }
    };

    return (
        <div className="data-source-tile">
            {organization && (
                <div className="data-source-org-badge mb-2">{organization}</div>
            )}
            <div className="data-source-content">
                {detailUrl ? (
                    <Link
                        to={detailUrl}
                        className="text-decoration-none text-reset"
                    >
                        <h3 className="data-source-title fw-semibold mb-3">
                            {title}
                        </h3>
                    </Link>
                ) : (
                    <h3 className="data-source-title fw-semibold mb-3">
                        {title}
                    </h3>
                )}
                <p className="data-source-description mb-2">{description}</p>
                <p className="data-source-metadata">{metadata}</p>
            </div>
            <div className="d-flex flex-column gap-2">
                <Button
                    className="data-source-cta-btn btn-dark w-100"
                    onClick={handleClick}
                    aria-label={`Ask Bili about ${title}`}
                >
                    {ctaText}
                </Button>
                {detailUrl && (
                    <Link
                        to={detailUrl}
                        className="btn btn-outline-dark btn-sm w-100"
                    >
                        Learn more
                    </Link>
                )}
            </div>
        </div>
    );
});

DataSourceTile.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    metadata: PropTypes.string.isRequired,
    detailUrl: PropTypes.string,
    ctaText: PropTypes.string.isRequired,
    ctaLink: PropTypes.string,
    onClick: PropTypes.func,
    organization: PropTypes.string,
};

export default DataSourceTile;
